import http from './api'

const url = '/pools'

export const httpGetPools = (params) => {
  console.log("httpGetPools called with params:", params);
  console.log("httpGetPools URL:", `${url}/`);
  
  return http({
    url: `${url}/`,
    method: 'GET',
    params,
  }).then(response => {
    console.log("httpGetPools success:", response);
    return response;
  }).catch(error => {
    console.error("httpGetPools error:", error);
    throw error;
  });
}

export const httpGetPool = (id) => {
  console.log("httpGetPool called with id:", id);
  return http({
    url: `${url}/${id}/`,
    method: 'GET',
  })
}

export const httpCreatePool = (data) => {
  console.log("httpCreatePool called with data:", data);
  return http({
    url: `${url}/`,
    method: 'POST',
    data,
  })
}

export const httpUpdatePool = (id, data) => {
  console.log("httpUpdatePool called with id:", id, "data:", data);
  return http({
    url: `${url}/${id}/`,
    method: 'PATCH',
    data,
  })
}

export const httpDeletePool = (id) => {
  console.log("httpDeletePool called with id:", id);
  return http({
    url: `${url}/${id}/`,
    method: 'DELETE',
  })
} 